import { Component } from '@angular/core';
import { ModalController, LoadingController, AlertController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

import { ConfigService } from 'src/app/provider/config.service';
import { Events } from 'src/app/provider/events.service';
import { ApiService } from 'src/app/provider/api.service';
import { endpoints } from 'src/app/constant/endpoints';
import { first } from 'rxjs';

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.page.html',
    styleUrls: ['./feedback.page.scss'],
})
export class FeedbackPage {
    loading: any;
    bookings: any;
    customer_id: any;
    feedbackForm: FormGroup;
    constructor(
        private events: Events,
        public formBuilder: FormBuilder,
        private toastCtrl: ToastController,
        private loadingCtrl: LoadingController,
        private alertCtrl: AlertController,
        private modalCtrl: ModalController,
        public translate: TranslateService,
        private configService: ConfigService,
        private apiService: ApiService,
    ) {
        console.log(this.bookings);
        console.log(this.customer_id);

        this.feedbackForm = this.formBuilder.group({
            subject: new FormControl('', Validators.compose([
                Validators.minLength(6),
                Validators.maxLength(50),
            ])),
            message: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(1250),
            ])),
            score: new FormControl('', Validators.compose([
                Validators.required,
            ])),
        });
    }
    submitFeedbackData = () => {
        this.showLoading();
        this.apiService
            .post(endpoints.feedback + '/' + this.bookings.slug, this.feedbackForm.value)
            .pipe(first())
            .subscribe(async (response) => {
                console.log(response);
                this.hideLoading();
                if (response.success) {
                    this.toastMessage(response.message);
                    this.modalCtrl.dismiss({'is_feedback_given': 1}, 'close');
                } else if (response.code == 401) {
                    this.events.publish('user:login', { user: null, time: new Date() });
                }
            }, (err) => {
                this.hideLoading();
                if (err.status == 422) {
                    this.toastMessage("please_fill_all_mandatory_fields");
                } else if (err.status == 400) {
                    this.toastMessage(err.error.message);
                }
            });
        console.log();
    }
    showLoading = async () => {
        this.loadingCtrl.create({
            message: this.translate.instant('please_wait'),
            cssClass: 'loader_class',
        }).then(a => {
            a.present().then(() => {
                console.log('presented');

            });
        });
    }
    hideLoading = async () => {
        setTimeout(async () => {
            try {
                this.loadingCtrl.dismiss();
            } catch (error) {
                console.log(error);
            }
        }, 1000);
    }
    alertPresent = async (header: string, message: string) => {
        let alertElem = await this.alertCtrl.create({
            header: this.translate.instant(header),
            message: this.translate.instant(message),
            buttons: [this.translate.instant('ok')]
        });
        return alertElem.present();
    }
    toastMessage = async (msg) => {
        await this.toastCtrl.create({
            message: this.translate.instant(msg),
            duration: 4000,
            position: 'top',
            color: 'primary'
        }).then((toastElem) => toastElem.present());
    }
    loadingPresent = async () => {
        this.loading = await this.loadingCtrl.create({
            spinner: 'crescent',
            cssClass: 'my-loading-class'
        });
        return this.loading.present();
    }
    loadingDismiss = async () => {
        await this.loading.dismiss();
    }
    closeModal = () => {
        this.modalCtrl.dismiss({'is_feedback_given': 0}, 'close');
    }
}
